import { Parallax } from 'react-parallax';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div >

      <Parallax strength={300} bgImage="images/bg.jpg">
        <div className="section">
        </div>
      </Parallax>

      <div className="container" id="apie-bostono-terjerus">
        <div className="section">

          <div className="row">
            <div className="col s12 center">
              <h3><i className="mdi-content-send brown-text"></i></h3>
              <h4>APIE BOSTONO TERJERUS</h4>
              <p className="headline light">Bostono terjerai tapo populiarūs nuo pat veislės atsiradimo pradžios, šiek tiek daugiau nei prieš šimtmetį. Iš pradžių jie buvo veisiami kaip kovos šunys, tačiau šiandien jie yra meilūs ir švelnūs draugai, turintys išvaizdą, lyg dėvėtų smokingą , nuo ko gavo slapyvardį &quot;Amerikos džentelmenas&quot;. <Link to="/about-boston-terrier">Plačiau...</Link></p>
            </div>
          </div>
          <div className="row center">
            <div >
              <iframe title="about-boston-terrier" src="https://www.youtube.com/embed/G3dWns5n21s?ecver=2" width="100%"></iframe>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col s12 m4">
            <div className="icon-block">
              <div className="center"><img src="images/what.png" alt="what" /> </div>
              <h5 className="center">KĄ DAROME</h5>

              <p className="light">Bostono terjerus veisiame atsakingai, ypatingą dėmesį skirdami genetikai bei paveldimiems bruožams. Visų geriausių veislės savybių išsaugojimas bei tobulinimas yra pagrindinis prioritetas veisiant šuniukus.</p>
            </div>
          </div>

          <div className="col s12 m4">
            <div className="icon-block">
              <div className="center"><img src="images/why.png" alt="why" /> </div>
              <h5 className="center">KODĖL DAROME</h5>

              <p className="light">Bostono terjerai yra šunys kuriuos veisiame, šunys kuriuos mylime ir šunys kuriems skiriame didelę savo gyvenimo dalį.... Norime populiarinti ir plačiau supažindinti su šia ypatinga veisle bei veisti tik pačius geriausius, sveikus šuniukus.</p>
            </div>
          </div>

          <div className="col s12 m4">
            <div className="icon-block">
              <div className="center"><img src="images/how.png" alt="how" /> </div>
              <h5 className="center">KAIP DAROME</h5>

              <p className="light">Veisiami tik idealiausiai veisles standartus atitinkantys šunys. Veterinarijos gydytojų ir kitų profesionalų pagalba kruopščiai atrenkami partneriai veisimui iš žinomų bei pripažintų veislynų, tam kad būsimi mažyliai turėtu nepriekaištingus šios veislės genus.</p>
            </div>
          </div>
        </div>

      </div>

      <Parallax bgImage="images/dark_bg.jpg" strength={400}>
        <div className="section no-pad-bot" id="musu-sunys">
          <div className="container">
            <div className="row center">
              <h4 className="header col s12 light">MŪSŲ ŠUNYS</h4>
              <p className="headline light">Šiuo metu turima viena kalė. Greitu metu numatytas vieno patinėlio bei kalytės įsigijimas. Turime
                tvirtą nuostatą jog šunys gyvens kartu su mumis kaip pilnaverčiai šeimos nariai. Šuniukai nuo mažens
                bus pratinami prie žmonių, socializuojami.</p>
            </div>
            <div className="row">
              <div className="col s12 l4">
                <div>
                  <div className="row center">
                    <Link to="/about-chika" ><img src="photos/chika/portrait.png" title="Cika Bostono Terjeras" alt="bostono-terjeras-Cika"/></Link>

                    <h5>ČIKA</h5>
                  </div>
                  <div className="row">
                    <p className="light">Ji aktyvi, drąsi ir žaisminga, atitinkanti visus veislės standartus bei idealios sveikatos būklės (turime tai patvirtinančius medicininius tyrimus).
                      Parodose puikiai vertinama teisėjų. Tikimės geriausias savybes perduos savo šuniukams. Pirma vada buvo 2018 pradžioje.
                      <Link to="/about-chika" >Plačiau apie Čiką.</Link> </p>
                  </div>
                </div>

              </div>
              <div className="col s12 l4">
                <div>
                  <div className="row center">
                    <Link to="/about-sierra" ><img src="photos/sierra/portrait.png" title="Sierra Bostono Terjeras" alt="bostono-terjeras-sierra" /></Link>

                    <h5>SIERRA</h5>
                  </div>
                  <div className="row">
                    <p className="light">Kompaktiška (trumpesnė), labai meili bei prieraiši, itin draugiška su visais žmonėmis bei puikiai sutaria su mažais vaikais.
                      Šiek tiek ramesnio būdo bei temperamento. Parodose teisėjai atkreipia dėmesį į išraiškingą, gražią galvą. Pirma vada buvo 2021 kovo mėnesį.
                      <Link to="/about-sierra" >Plačiau apie Sierrą.</Link> </p>
                  </div>
                </div>

              </div>
              <div className="col s12 l4">
                <div>
                  <div className="row center">
                    <Link to="/about-diva" ><img src="photos/diva/portrait.png" title="Diva Bostono Terjeras" alt="bostono-terjeras-diva" /></Link>

                    <h5>DIVA</h5>
                  </div>
                  <div className="row">
                    <p className="light">Mūsų veislyne 2021 metais gimusi kalytė. Vidutinio ūgio bei svorio, žaisminga, temperatinga, tipiško „bostoniško“ charakterio.
                      Kaip ir jos mama (Sierra), puikiai sutaria su mažais vaikais bei mėgsta būti glostoma. Parodose puikiai vertinama teisėjų. Pirma vada planuojama 2023 metų pavasarį.
                      <Link to="/about-diva" >Plačiau apie Divą.</Link> </p>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </Parallax>

      <div className="container" id="naujausia-suniuku-vada">
        <div className="section">
          <div className="row center">
            {/* <p className="headline light">Planuojama 2019 m. vasarą.</p> */}
            <h4 className="header col s12 light">NAUJAUSIA ŠUNIUKŲ VADA</h4>
            <Link to="/breed-e"><img src="photos/breed-e/pedigree.jpg" className="max-width-100" title="E vada" alt="E vada" /></Link>
          </div>
        </div>
      </div>

      <Parallax bgImage="images/dark_bg.jpg">
        <div className="section no-pad-bot">
          <div className="container">
            <div className="row center">
              <h4 className="header col s12 light">APIE MUS</h4>
              <p className="headline light">Pamilome bostono terjerų veislę nuo pat pirmos pažinties dienos su ja. Skiriame šiems šunims daug
                savo dėmesio bei laiko. Ateityje dar laukia įdomūs darbai ir norime padėkoti visiems padėjusiems
                mums šiame kelyje. Ypatingas dėkui <a href="http://toyclub.lt/" target="_blank" rel="noopener noreferrer">Dekoratyvinių Šunų klubui</a> bei
                <a href="https://www.facebook.com/4pedutes" target="_blank" rel="noopener noreferrer"> "4 pėdutės"</a>.</p>
            </div>

            <div className="row">
              <div className="col s12 l6">
                <div className="container">
                  <div className="row">

                    <img src="photos/Agne.png" width="400px" height="400px" title="Agne" alt="Agne" />
                    <h5 className="center">AGNĖ</h5>
                  </div>
                  <div className="row">
                    <p className="light">Agnė domisi šunų dresūra ir mokosi hendlingo, lankosi atitinkamuose kursuose, renginiuose. Aktyviai
                      dalyvauja šunų parodose, yra dekoratyvinių šunų klubo narė. Agnei patinka ilgi pasivaikščiojimai su
                      šunimis bei žaidimai su jais lauke.</p>
                  </div>
                </div>
              </div>
              <div className="col s12 l6">
                <div className="container">
                  <div className="row">

                    <img src="photos/Darius.png" width="400px" height="400px" title="Darius" alt="Darius" />
                    <h5 className="center">DARIUS</h5>
                  </div>
                  <div className="row">
                    <p className="light">Darius yra šunų mylėtojas aktyviai bendraujantis su bostono terjerų veisėjais Lietuvoje ir pasaulyje.
                      Laisvu laiku domisi kinologija, studijuoja šunų elgesį, veislių atsiradimo istoriją. Kasdien siekia
                      sužinoti daugiau apie šiuos nuostabius gyvūnus bei apie jų veisimą</p>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

      </Parallax>

    </div>
  );

}